import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-medicine-finder',
  imports: [],
  templateUrl: './medicine-finder.component.html',
  styleUrl: './medicine-finder.component.scss'
})
export class MedicineFinderComponent {}
